
















































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { PolicyUi } from '@/common/Policy';
import Dropdown from '@/components/Global/Menu/Dropdown.vue';
import MenuItem from '@/components/Global/Menu/Item.vue';
import Auth from '@/services/Auth';
import Brand from '@/services/Brand';
import { Features } from '@/services/Features';
import RiskResources from './RiskResources.vue';

@Component({
	name: 'MainMenu',
	components: {
		MenuItem,
		Dropdown,
		RiskResources,
	},
})
export default class MmicMenu extends Vue {
	@Getter('thirtyDayPolicies', { namespace: 'Policy' }) private thirtyDayPolicies: PolicyUi[];
	@Getter('policies', { namespace: 'Policy' }) private policies: PolicyUi[];
	private readonly Features = Features;
	private get orgMembersTitle(): string {
		if (this.$store.state.Auth === undefined) {
			return '';
		}

		const isAgencyAdmin: boolean =
			this.$store.state.Auth.user.isAgent === 'true' &&
			this.$store.state.Auth.user.isOrgAdmin === 'true';
		return isAgencyAdmin ? 'Agents' : 'Users';
	}

	private get showTopMenuCoiMenuItem(): boolean {
		return (
			Brand.getBrand() === 'umia' &&
			!Features.isUmiaPolicyDocumentsEnabled &&
			(Auth.checkPermission('VIEW_COI') || Auth.checkPermission('VIEW_POLICY_INFO'))
		);
	}

	private get showTopMenuPoliciesMenuItem(): boolean {
		const brand: string = Brand.getBrand();
		return (
			(brand === 'amic' || (brand === 'insurecareteams' && !Auth.isBrokerageSite())) &&
			(Auth.checkPermission('VIEW_COI') || Auth.checkPermission('VIEW_POLICY_INFO'))
		);
	}

	private get showTopMenuPoliciesAndReportsDropDown(): boolean {
		const brand: string = Brand.getBrand();
		return (
		(brand === 'mmic' || (brand === 'rrg') || (brand === 'umia' && Features.isUmiaPolicyDocumentsEnabled)) &&
			this.thirtyDayPolicies.length > 0
		);
	}

	private get showSubMenuPolicyDocumentsMenuItem(): boolean {
		return Auth.checkPermission('VIEW_COI') || Auth.checkPermission('VIEW_POLICY_INFO');
	}

	private get showTopMenuClientsListMenuItem(): boolean {
		return Brand.getBrand() === 'insurecareteams' && Auth.isBrokerageSite();
	}

	private get showTopMenuQuotesListMenuItem(): boolean {
		return Brand.getBrand() === 'insurecareteams' && Auth.isBrokerageSite();
	}

	private get showTopMenuSavedQuotesMenuItem(): boolean {
		return Brand.getBrand() === 'insurecareteams' && !Auth.isBrokerageSite();
	}

	private get showTopMenuPaymentsDropDown(): boolean {
		return Auth.checkPermission('BILL_PAY') && this.thirtyDayPolicies.length > 0;
	}

	private get showSubMenuRecurringPaymentsMenuItem(): boolean {
                const brand: string = Brand.getBrand();
		return brand === 'mmic'; //  || brand === 'rrg';

	}

	private get showSubMenuBillingStatementsMenuItem(): boolean {
		const brand: string = Brand.getBrand();
		return brand === 'amic' || brand === 'mmic' || brand === 'rrg';
	}

	private get showTopMenuClaimDropDown(): boolean {
		return Auth.checkPermission('REPORT_CLAIM') && this.policies.length > 0;
	}

	private get showTopMenuAccountAdminDropDown(): boolean {
		const brand: string = Brand.getBrand();
		return (
			(brand === 'amic' || brand === 'mmic' || brand === 'umia' || brand === 'rrg') &&
			Auth.checkPermission('ACCOUNT_ADMIN')
		);
	}
}
